export default __webpack_public_path__ + "media/6775135b2bca3c825c56c1e8cfeda3df9767af78521cd96e161553dc5f251412.svg";